import { useLocation } from 'react-router-dom';

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://foodgogo.org';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
  noIndex?: boolean;
}

export default function SEO({ title, description, keywords, ogType = 'website', ogImage, schema, noIndex }: SEOProps) {
  const location = useLocation();
  const canonicalUrl = `${SITE_URL}${location.pathname === '/' ? '/' : location.pathname}`;
  const lastModified = '2026-05-18';

  const fullSchema = schema
    ? {
        '@context': 'https://schema.org',
        ...schema,
      }
    : null;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="last-modified" content={lastModified} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {fullSchema && (
        <script type="application/ld+json">{JSON.stringify(fullSchema)}</script>
      )}
    </>
  );
}